const Button3 = ({ value }) => {
  return (
    <div className="cursor-pointer text-center px-2 py-1 w-fit transition-all hover:scale-[1.05] text-[12px] md:text-[13px] xl:text-sm font-medium text-white bg-[#000000] border-[1px] border-[#000000] rounded-2xl lg:rounded-full">
      {value}
    </div>
  );
};

export default Button3;
